<ng-template #postsContent>
  <div class="mx-auto max-w-[1600px]" [style.display]="mixedMode ? 'contents' : null">

    <div class="masonry-grid" [class.masonry-grid-3]="embedded && !featured && gridCols !== 4" [class.home-uniform-grid]="uniform" [style.display]="mixedMode ? 'contents' : null" #masonryGrid>
      <article *ngFor="let post of visiblePosts; trackBy: trackById"
        class="masonry-item uniform-card bg-white rounded-2xl border border-[#e6e6e6] shadow-[0_1px_1px_rgba(0,0,0,0.04)] p-3 cursor-pointer transition-shadow hover:shadow-md"
        [style.order]="mixedMode ? post.globalOrder : null"
        [style.grid-row]="post.gridSpan || null"
        #cardRef (click)="navigateToPost(post.id)">

        <!-- Removed-by-admin banner (only ever present for the post's own author) -->
        <div *ngIf="post.isRemovedByAdmin"
          class="mb-2 flex items-center gap-2 rounded-lg bg-red-50 border border-red-200 text-red-700 text-xs font-medium px-3 py-2"
          (click)="$event.stopPropagation()">
          <svg class="h-4 w-4 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M12 9v3.75m9-.75a9 9 0 11-18 0 9 9 0 0118 0zm-9 3.75h.008v.008H12v-.008z" />
          </svg>
          <span>This content has been removed by admin and is only visible to you.</span>
        </div>

        <!-- Host row -->
        <div class="flex items-center gap-2 sm:gap-3" (click)="$event.stopPropagation()">

          <div class="flex-shrink-0">
            <img *ngIf="post.acceptedCollaborators.length === 0" class="h-9 w-9 sm:h-10 sm:w-10 rounded-full object-cover cursor-pointer"
              [src]="post.hostAvatar" [alt]="post.hostName"
              (click)="$event.stopPropagation()" [routerLink]="['/profile', post.hostName, 'post']"
              onerror="this.src='https://ui-avatars.com/api/?name=' + encodeURIComponent(this.alt || 'U') + '&background=FFD4E0&color=D31148'" />

            <div *ngIf="post.acceptedCollaborators.length > 0" class="flex -space-x-2 items-center"
              [class.cursor-pointer]="post.acceptedCollaborators.length >= 1"
              (click)="post.acceptedCollaborators.length >= 1 ? showCollaboratorsModal(post) : null; $event.stopPropagation()">
              <img class="h-9 w-9 rounded-full object-cover border-2 border-white" [src]="post.hostAvatar"
                [alt]="post.hostName"
                onerror="this.src='https://ui-avatars.com/api/?name=' + encodeURIComponent(this.alt || 'U') + '&background=FFD4E0&color=D31148'" />
              <img class="h-7 w-7 rounded-full object-cover border-2 border-white"
                [src]="post.acceptedCollaborators[0].profileImage?.urlSmall"
                [alt]="post.acceptedCollaborators[0].displayName"
                onerror="this.src='https://ui-avatars.com/api/?name=' + encodeURIComponent(this.alt || 'U') + '&background=FFD4E0&color=D31148'" />
            </div>
          </div>

          <!-- Name and location -->
          <div class="flex-1 min-w-0 overflow-hidden">
            <div class="font-semibold text-gray-700 text-sm sm:text-base truncate">
              <span class="cursor-pointer" [routerLink]="['/profile', post.hostName, 'post']"
                (click)="$event.stopPropagation()">{{ post.hostName }}</span>

              <ng-container *ngIf="post.acceptedCollaborators.length === 1">
                <span class="font-normal text-gray-500"> with </span>
                <span class="font-semibold text-gray-700 cursor-pointer"
                  [routerLink]="['/profile', post.acceptedCollaborators[0].userName, 'post']"
                  (click)="$event.stopPropagation()">{{ post.acceptedCollaborators[0].userName }}</span>
              </ng-container>

              <ng-container *ngIf="post.acceptedCollaborators.length >= 2">
                <span class="font-normal text-gray-500"> and </span>
                <span class="font-semibold text-gray-700 cursor-pointer hover:text-gray-900"
                  (click)="showCollaboratorsModal(post); $event.stopPropagation()">
                  {{ post.acceptedCollaborators.length }} {{ post.acceptedCollaborators.length === 1 ? 'other' :
                  'others' }}
                </span>
              </ng-container>
            </div>
            <div class="text-sm text-gray-400" *ngIf="post.location">{{ post.location }}</div>
          </div>

          <div class="flex items-center gap-2 sm:gap-3 flex-shrink-0">
          <!-- Friend request button -->
          <button (click)="onFriendButtonClick(post, $event)"
            *ngIf="!post.isMyPost && post.acceptedCollaborators.length === 0"
            [disabled]="post.friendshipStatus === 'BLOCKED'" [title]="friendButtonTitle(post.friendshipStatus)"
            class="text-gray-400 flex-shrink-0 transition-colors disabled:opacity-40 disabled:cursor-not-allowed hover:text-[#D31148]">
            <svg *ngIf="post.friendshipStatus === 'NONE'" class="h-6 w-6" viewBox="0 0 24 24" fill="none"
              stroke="#D31148" stroke-width="2">
              <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
              <circle cx="9" cy="7" r="4" />
              <line x1="19" y1="8" x2="19" y2="14" />
              <line x1="22" y1="11" x2="16" y2="11" />
            </svg>
            <svg *ngIf="post.friendshipStatus === 'PENDING_SENT'" class="h-6 w-6" viewBox="0 0 24 24" fill="none"
              stroke="#f97316" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
              <circle cx="9" cy="7" r="4" />
              <line x1="17" y1="8" x2="23" y2="14" />
              <line x1="23" y1="8" x2="17" y2="14" />
            </svg>
            <svg *ngIf="post.friendshipStatus === 'PENDING_RECEIVED'" class="h-6 w-6" viewBox="0 0 24 24" fill="none"
              stroke="#6366f1" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
              <circle cx="9" cy="7" r="4" />
              <polyline points="16 11 18 13 22 9" />
            </svg>
            <svg *ngIf="post.friendshipStatus === 'FRIENDS'" class="h-6 w-6" viewBox="0 0 24 24" fill="none"
              stroke="#10b981" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
              <circle cx="9" cy="7" r="4" />
              <polyline points="16 11 18 13 22 9" />
            </svg>
            <svg *ngIf="post.friendshipStatus === 'BLOCKED'" class="h-6 w-6" viewBox="0 0 24 24" fill="none"
              stroke="#9ca3af" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <circle cx="12" cy="12" r="10" />
              <line x1="4.93" y1="4.93" x2="19.07" y2="19.07" />
            </svg>
          </button>

          <!-- Three-dot action menu -->
          <div class="relative inline-block" *ngIf="!post.isRemovedByAdmin" (click)="$event.stopPropagation()">
            <button (click)="togglePostActionMenu(post, $event)"
              class="flex items-center justify-center w-5 h-8 rounded-full hover:bg-gray-200 transition-colors text-gray-500">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M10.2441 6C10.2441 5.0335 11.0276 4.25 11.9941 4.25H12.0041C12.9706 4.25 13.7541 5.0335 13.7541 6C13.7541 6.9665 12.9706 7.75 12.0041 7.75H11.9941C11.0276 7.75 10.2441 6.9665 10.2441 6ZM10.2441 18C10.2441 17.0335 11.0276 16.25 11.9941 16.25H12.0041C12.9706 16.25 13.7541 17.0335 13.7541 18C13.7541 18.9665 12.9706 19.75 12.0041 19.75H11.9941C11.0276 19.75 10.2441 18.9665 10.2441 18ZM11.9941 10.25C11.0276 10.25 10.2441 11.0335 10.2441 12C10.2441 12.9665 11.0276 13.75 11.9941 13.75H12.0041C12.9706 13.75 13.7541 12.9665 13.7541 12C13.7541 11.0335 12.9706 10.25 12.0041 10.25H11.9941Z" />
              </svg>
            </button>
            <div *ngIf="activeActionPostId === post.id"
              class="absolute right-0 top-full mt-1 w-44 bg-white rounded-xl shadow-lg border border-gray-100 p-2 z-50">
              <ng-container *ngIf="post.isMyPost">
                <button (click)="toggleComments(post, $event)" [disabled]="togglingCommentsId === post.id"
                  class="flex w-full items-center gap-2 px-3 py-2 text-sm text-left rounded-lg disabled:opacity-50"
                  [ngClass]="post.commentsDisabled ? 'text-red-500 hover:bg-red-50 hover:text-red-700' : 'text-gray-600 hover:bg-gray-100 hover:text-gray-800'">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                    stroke-linecap="round" stroke-linejoin="round" class="flex-shrink-0">
                    <path
                      d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z" />
                    <line *ngIf="post.commentsDisabled" x1="2" y1="2" x2="22" y2="22" />
                  </svg>
                  {{ post.commentsDisabled ? 'Turn on comments' : 'Turn off comments' }}
                </button>
                <button (click)="editPost(post, $event)"
                  class="flex w-full items-center gap-2 px-3 py-2 text-sm text-left text-gray-600 rounded-lg hover:bg-gray-100 hover:text-gray-800">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                    stroke-linecap="round" stroke-linejoin="round" class="flex-shrink-0">
                    <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
                    <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
                  </svg>
                  Edit Post
                </button>
                <button (click)="confirmDeletePost(post, $event)"
                  class="flex w-full items-center gap-2 px-3 py-2 text-sm text-left text-red-500 rounded-lg hover:bg-red-50 hover:text-red-700">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                    stroke-linecap="round" stroke-linejoin="round" class="flex-shrink-0">
                    <polyline points="3 6 5 6 21 6" />
                    <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" />
                    <path d="M10 11v6" />
                    <path d="M14 11v6" />
                    <path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2" />
                  </svg>
                  Delete Post
                </button>
              </ng-container>
              <ng-container *ngIf="!post.isMyPost">
                <button *ngIf="!post.isFollowed && post.acceptedCollaborators.length === 0"
                  (click)="follow($event, post)"
                  class="flex w-full items-center gap-2 px-3 py-2 text-sm text-left text-gray-600 rounded-lg hover:bg-gray-100 hover:text-gray-800">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                    stroke-linecap="round" stroke-linejoin="round" class="flex-shrink-0">
                    <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                    <circle cx="9" cy="7" r="4" />
                    <line x1="20" y1="8" x2="20" y2="14" />
                    <line x1="17" y1="11" x2="23" y2="11" />
                  </svg>
                  Follow
                </button>
                <button *ngIf="post.isFollowed && post.acceptedCollaborators.length === 0"
                  (click)="unfollow($event, post)"
                  class="flex w-full items-center gap-2 px-3 py-2 text-sm text-left text-gray-600 rounded-lg hover:bg-gray-100 hover:text-gray-800">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                    stroke-linecap="round" stroke-linejoin="round" class="flex-shrink-0">
                    <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                    <circle cx="9" cy="7" r="4" />
                    <line x1="17" y1="11" x2="23" y2="11" />
                  </svg>
                  Unfollow
                </button>
                <button (click)="reportPost(post, $event)"
                  class="flex w-full items-center gap-2 px-3 py-2 text-sm text-left text-red-500 rounded-lg hover:bg-red-50 hover:text-red-700">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                    stroke-linecap="round" stroke-linejoin="round" class="flex-shrink-0">
                    <path d="M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1z" />
                    <line x1="4" y1="22" x2="4" y2="15" />
                  </svg>
                  Report Post
                </button>
                <button (click)="blockPostUser(post, $event)"
                  class="flex w-full items-center gap-2 px-3 py-2 text-sm text-left text-red-500 rounded-lg hover:bg-red-50 hover:text-red-700">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                    stroke-linecap="round" stroke-linejoin="round" class="flex-shrink-0">
                    <circle cx="12" cy="12" r="10" />
                    <line x1="4.93" y1="4.93" x2="19.07" y2="19.07" />
                  </svg>
                  Block User
                </button>
              </ng-container>
            </div>
          </div>
          </div>
        </div>

        <!-- Background pattern post -->
        <div *ngIf="post.hasBackground && post.images.length === 0"
          class="uniform-media relative mt-3 rounded-xl overflow-hidden flex items-center justify-center"
          [style.min-height]="post.title.length < 100 ? '200px' : '260px'"
          [style.max-height]="post.title.length > 500 ? '400px' : '320px'"
          [ngClass]="getPatternClass(post.backgroundPattern)" [style.background-color]="post.backgroundBg">

          <div class="absolute inset-0 px-5 py-5 overflow-y-auto custom-scrollbar"
            [class.flex]="post.title.length < 100" [class.items-center]="post.title.length < 100"
            [class.justify-center]="post.title.length < 100">
            <p class="text-xl font-bold leading-snug text-white background-text"
              [class.text-center]="post.title.length < 100"
              style="text-shadow: 0 1px 5px rgba(0,0,0,0.3); white-space: pre-wrap; word-wrap: break-word; width: -webkit-fill-available;"
              [innerHTML]="getHighlightedCaption(post.title)" (click)="onCaptionClick($event)">
            </p>
          </div>
        </div>

        <!-- Image/Video carousel -->
        <div *ngIf="post.images.length > 0" class="uniform-media relative mt-3 rounded-xl overflow-hidden"
          (click)="navigateToPost(post.id)">
          <div class="relative w-full rounded-xl overflow-hidden bg-gray-100 select-none" appSwipe
            [swipeDisabled]="post.images.length <= 1" (swipeLeft)="onSlideSwipe(post, 1, $event)"
            (swipeRight)="onSlideSwipe(post, -1, $event)">
            <ng-container *ngFor="let img of post.images; let i = index">
              <img *ngIf="img.type === 'image'" [src]="img.url" [alt]="post.title"
                class="w-full object-cover carousel-slide" [class.block]="i === post.activeSlide"
                [class.hidden]="i !== post.activeSlide" (load)="onImageLoad($event)" />
              <!-- stopPropagation: the card wraps this in a navigate-to-post click, and
                   tapping the native play control bubbles up to it — so on touch devices
                   pressing play opened the detail screen instead of playing. -->
              <video *ngIf="img.type === 'video'" [appLazyMedia]="img.url" class="w-full object-cover carousel-slide"
                [class.block]="i === post.activeSlide" [class.hidden]="i !== post.activeSlide" controls muted
                playsinline (click)="$event.stopPropagation()" (loadedmetadata)="onVideoLoad($event)"
                (play)="onVideoPlay($event)"></video>
            </ng-container>
          </div>

          <ng-container *ngIf="post.images.length > 1">
            <button (click)="prevSlide(post, $event)"
              class="absolute left-2 top-1/2 -translate-y-1/2 z-10 flex h-7 w-7 items-center justify-center rounded-full bg-white/80 text-[#D31148] shadow hover:bg-white transition-colors">
              <svg class="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"
                stroke-linecap="round" stroke-linejoin="round">
                <path d="M15 18l-6-6 6-6" />
              </svg>
            </button>
            <button (click)="nextSlide(post, $event)"
              class="absolute right-2 top-1/2 -translate-y-1/2 z-10 flex h-7 w-7 items-center justify-center rounded-full bg-white/80 text-[#D31148] shadow hover:bg-white transition-colors">
              <svg class="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"
                stroke-linecap="round" stroke-linejoin="round">
                <path d="M9 18l6-6-6-6" />
              </svg>
            </button>
          </ng-container>
        </div>

        <div *ngIf="post.images.length > 1" class="mt-2 flex items-center justify-center gap-1.5">
          <button *ngFor="let img of post.images; let i = index" (click)="goToSlide(post, i, $event)"
            class="rounded-full transition-all duration-300"
            [class]="i === post.activeSlide ? 'h-2 w-4 bg-[#D31148]' : 'h-2 w-2 bg-[#d9d9d9]'">
          </button>
        </div>

        <!-- Description -->
        <div *ngIf="post.images.length > 0 && post.description" class="mt-3">
          <div class="uniform-clamp-2 text-sm leading-relaxed whitespace-pre-wrap break-words mention-text" style="color: #4b5563;"
            [class.line-clamp-4]="!post.expanded" [innerHTML]="getHighlightedCaption(post.description)"
            (click)="onCaptionClick($event)">
          </div>
          <button *ngIf="!post.expanded && post.description.length > 200"
            (click)="expandPost(post); $event.stopPropagation()"
            class="uniform-hide text-sm font-semibold text-gray-600 mt-0.5 hover:underline">
            ...Read More
          </button>
          <button *ngIf="post.expanded" (click)="collapsePost(post); $event.stopPropagation()"
            class="uniform-hide text-sm font-semibold text-gray-600 mt-0.5 hover:underline">
            Show Less
          </button>

          <!-- Open Graph card for the first link in the caption. This block only
               renders for posts with media, so background posts never get one. -->
          <app-link-preview class="uniform-hide" [text]="post.description" [debounceMs]="0"></app-link-preview>
        </div>

        <div *ngIf="post.hashtags.length > 0" class="uniform-one-line mt-3">
          <div class="flex flex-wrap gap-1.5">
            <span *ngFor="let tag of post.hashtags" (click)="goToHashtag(tag, $event)"
              class="inline-block text-sm font-medium text-[#D31148] hover:underline cursor-pointer">
              #{{ tag }}
            </span>
          </div>
        </div>
        <!-- Home-page equal-height grid only: pushes the footer to the card bottom -->
        <div class="uniform-spacer"></div>
        <ng-container *ngIf="post.totalReactions > 0">
          <button class="flex items-center mt-3 gap-1.5 cursor-pointer hover:opacity-80 transition-opacity"
            (click)="openReactionModal(post); $event.stopPropagation()">
            <!-- Stacked emoji bubbles for top reaction types -->
            <span class="flex items-center" style="gap:-4px;">
              <span *ngFor="let t of post.topTypes; let i = index"
                class="flex items-center justify-center rounded-full border-2 border-white shadow-sm"
                [style.background]="getReactionConfig(t)?.bg" [style.width]="'22px'" [style.height]="'22px'"
                [style.font-size]="'13px'" [style.line-height]="'1'" [style.margin-left]="i > 0 ? '-6px' : '0'"
                [style.z-index]="10 - i">
                {{ getReactionConfig(t)?.emoji }}
              </span>
            </span>
            <!-- "Name and X others" or just count -->
            <span class="text-sm text-gray-500">
              <ng-container *ngIf="post.recentUserName">
                <span class="font-medium text-gray-700">{{ post.recentUserName }}</span>
                <ng-container *ngIf="post.totalReactions > 1">
                  and {{ post.totalReactions - 1 }} {{ post.totalReactions - 1 === 1 ? 'other' : 'others' }}
                </ng-container>
              </ng-container>
              <ng-container *ngIf="!post.recentUserName">
                {{ post.totalReactions }}
              </ng-container>
            </span>
          </button>
        </ng-container>
        <!-- Reactions row -->
        <div class="mt-2 flex items-center justify-between" (click)="$event.stopPropagation()">
          <div class="flex items-center gap-4 text-md text-gray-400">
            <div class="relative flex items-center gap-1 select-none" style="overflow:visible;">
              <div *ngIf="post.showEmojiPicker"
                class="reaction-picker absolute z-[999] flex items-end gap-1 rounded-full bg-white px-3 py-2.5 shadow-[0_4px_20px_rgba(0,0,0,0.2)] border border-gray-100"
                style="bottom:calc(100% + 10px);left:-8px;pointer-events:auto;" (mouseleave)="closeEmojiPicker(post)">
                <button *ngFor="let r of REACTIONS; let i = index" (click)="onEmojiPick(post, r.type, $event)"
                  (mouseenter)="post.hoveredReaction = r.type" (mouseleave)="post.hoveredReaction = null"
                  class="reaction-emoji-btn flex flex-col items-center cursor-pointer"
                  [style.animation-delay.ms]="i * 30" [title]="r.label">
                  <span class="reaction-circle flex items-center justify-center rounded-full" [style.background]="r.bg"
                    [class.scale-125]="post.hoveredReaction === r.type"
                    [class.-translate-y-2]="post.hoveredReaction === r.type"
                    style="width:42px;height:42px;font-size:22px;line-height:1;transition:transform 0.15s cubic-bezier(0.34,1.56,0.64,1);">
                    {{ r.emoji }}
                  </span>
                </button>
              </div>
              <button
                class="flex items-center gap-1.5 rounded-lg px-1 py-0.5 transition-all duration-150 active:scale-90"
                (click)="onReactionClick(post)">
                <ng-container *ngIf="!post.myReaction">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <g opacity="0.7">
                      <path
                        d="M7.48047 18.35L10.5805 20.75C10.9805 21.15 11.8805 21.35 12.4805 21.35H16.2805C17.4805 21.35 18.7805 20.45 19.0805 19.25L21.4805 11.95C21.9805 10.55 21.0805 9.34997 19.5805 9.34997H15.5805C14.9805 9.34997 14.4805 8.84997 14.5805 8.14997L15.0805 4.94997C15.2805 4.04997 14.6805 3.04997 13.7805 2.74997C12.9805 2.44997 11.9805 2.84997 11.5805 3.44997L7.48047 9.54997"
                        stroke="currentColor" stroke-width="1.5" stroke-miterlimit="10" />
                      <path
                        d="M2.37988 18.35V8.55002C2.37988 7.15002 2.97988 6.65002 4.37988 6.65002H5.37988C6.77988 6.65002 7.37988 7.15002 7.37988 8.55002V18.35C7.37988 19.75 6.77988 20.25 5.37988 20.25H4.37988C2.97988 20.25 2.37988 19.75 2.37988 18.35Z"
                        stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                    </g>
                  </svg>
                </ng-container>
                <ng-container *ngIf="post.myReaction">
                  <span class="reaction-bounce flex items-center justify-center rounded-full"
                    [style.background]="getReactionConfig(post.myReaction)?.bg"
                    style="width:30px;height:30px;font-size:18px;line-height:1;">
                    {{ getReactionConfig(post.myReaction)?.emoji }}
                  </span>
                </ng-container>
              </button>
            </div>

            <span class="flex items-center gap-1 cursor-pointer" (click)="navigateToPostComments(post.id, $event)">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                <g opacity="0.7">
                  <path
                    d="M21 12C21 16.9706 16.9706 21 12 21C10.8029 21 9.6603 20.7663 8.61549 20.3419C8.41552 20.2607 8.31554 20.2201 8.23472 20.202C8.15566 20.1843 8.09715 20.1778 8.01613 20.1778C7.9333 20.1778 7.84309 20.1928 7.66265 20.2229L4.10476 20.8159C3.73218 20.878 3.54589 20.909 3.41118 20.8512C3.29328 20.8007 3.19933 20.7067 3.14876 20.5888C3.09098 20.4541 3.12203 20.2678 3.18413 19.8952L3.77711 16.3374C3.80718 16.1569 3.82222 16.0667 3.82221 15.9839C3.8222 15.9028 3.81572 15.8443 3.798 15.7653C3.77988 15.6845 3.73927 15.5845 3.65806 15.3845C3.23374 14.3397 3 13.1971 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                </g>
              </svg>
              {{ post.comments }}
            </span>

            <button class="flex items-center gap-1 hover:text-[#D31148] transition-colors"
              (click)="openShareSheet(post, $event)">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                <g opacity="0.7">
                  <path
                    d="M20.7914 12.6075C21.0355 12.3982 21.1575 12.2936 21.2023 12.1691C21.2415 12.0598 21.2415 11.9403 21.2023 11.831C21.1575 11.7065 21.0355 11.6019 20.7914 11.3926L12.3206 4.13202C11.9004 3.77182 11.6903 3.59172 11.5124 3.58731C11.3578 3.58348 11.2101 3.6514 11.1124 3.77128C11 3.90921 11 4.18595 11 4.73942V9.03468C8.86532 9.40813 6.91159 10.4898 5.45971 12.1139C3.87682 13.8846 3.00123 16.176 3 18.551V19.163C4.04934 17.8989 5.35951 16.8766 6.84076 16.166C8.1467 15.5395 9.55842 15.1684 11 15.0706V19.2607C11 19.8141 11 20.0909 11.1124 20.2288C11.2101 20.3487 11.3578 20.4166 11.5124 20.4128C11.6903 20.4084 11.9004 20.2283 12.3206 19.8681L20.7914 12.6075Z"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                </g>
              </svg>
              {{ post.shares }}
            </button>
          </div>

          <!-- Tagged people + Favourite star — bottom right -->
          <div class="flex items-center gap-3">
            <button *ngIf="post.mentions.length > 0" type="button"
              (click)="showTaggedPeopleModal(post, $event)" title="Tagged people"
              class="flex items-center justify-center text-gray-300 transition-colors hover:text-[#D31148]">
              <svg class="h-5 w-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                stroke-linecap="round" stroke-linejoin="round">
                <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
                <circle cx="9" cy="7" r="4" />
                <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
                <path d="M16 3.13a4 4 0 0 1 0 7.75" />
              </svg>
            </button>
            <button
              [class.text-[#D31148]]="post.isFavourite" [class.text-gray-300]="!post.isFavourite"
              (click)="toggleFavourite(post, $event)"
              [title]="post.isFavourite ? 'Remove from favourites' : 'Save to favourites'"
              class="flex items-center justify-center transition-colors hover:text-[#D31148]">
              <svg class="h-5 w-5" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"
                stroke-linecap="round" stroke-linejoin="round"
                [attr.fill]="post.isFavourite ? 'currentColor' : 'none'">
                <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>
              </svg>
            </button>
          </div>
        </div>

        <div class="text-sm font-normal text-gray-400 mt-2">{{ post.timeAgo }}</div>

      </article>
    </div>

    <!-- Covers the list while it's put back after returning from a post,
         so the user sees a loader instead of cards settling into place. -->
    <div *ngIf="isRestoring"
      class="fixed inset-0 z-30 flex items-center justify-center bg-white dark:bg-gray-900">
      <div class="h-9 w-9 animate-spin rounded-full border-4 border-[#e8e8e8] border-t-[#D31148]"></div>
    </div>

    <div *ngIf="isLoading" class="flex items-center justify-center py-10">
      <div class="h-9 w-9 animate-spin rounded-full border-4 border-[#e8e8e8] border-t-[#D31148]"></div>
    </div>

    <div *ngIf="!isLoading && visiblePosts.length === 0 && !mixedMode"
      class="flex flex-col items-center justify-center py-20 text-gray-400">
      <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"
        class="mb-3 opacity-40">
        <rect x="3" y="4" width="18" height="18" rx="2" />
        <line x1="16" y1="2" x2="16" y2="6" />
        <line x1="8" y1="2" x2="8" y2="6" />
        <line x1="3" y1="10" x2="21" y2="10" />
      </svg>
      <p class="text-sm">No posts found</p>
    </div>

    <div #scrollSentinel class="h-4" *ngIf="!mixedMode"></div>
  </div>

  <!-- COLLABORATORS MODAL -->
  <div *ngIf="showCollabModal" class="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4"
    (click)="closeCollaboratorsModal()">
    <div class="bg-white rounded-2xl max-w-sm w-full max-h-[80vh] overflow-hidden" (click)="$event.stopPropagation()">
      <div class="flex items-center justify-between p-4 border-b border-gray-200">
        <h3 class="font-bold text-lg">Collaborators</h3>
        <button (click)="closeCollaboratorsModal()" class="text-gray-400 hover:text-gray-600 transition-colors">
          <svg class="h-6 w-6" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        </button>
      </div>
      <div class="overflow-y-auto max-h-[calc(80vh-80px)]">
        <div class="flex items-center gap-3 p-4 hover:bg-gray-50 transition-colors cursor-pointer"
          [routerLink]="['/profile', selectedPost?.hostName, 'post']">
          <img [src]="selectedPost?.hostAvatar" class="h-12 w-12 rounded-full object-cover border-2 border-white"
            onerror="this.src='https://ui-avatars.com/api/?name=' + encodeURIComponent(this.alt || 'U') + '&background=FFD4E0&color=D31148'" />
          <div class="flex-1 min-w-0">
            <div class="font-semibold text-gray-900 truncate">{{ selectedPost?.hostName }}</div>
            <div class="text-sm text-gray-500">Author</div>
          </div>
        </div>
        <div *ngFor="let collab of selectedPost?.acceptedCollaborators"
          class="flex items-center gap-3 p-4 hover:bg-gray-50 transition-colors cursor-pointer"
          [routerLink]="['/profile', collab.userName, 'post']">
          <img [src]="collab.profileImage?.urlSmall" [alt]="collab.displayName"
            class="h-12 w-12 rounded-full object-cover border-2 border-white"
            onerror="this.src='https://ui-avatars.com/api/?name=' + encodeURIComponent(this.alt || 'U') + '&background=FFD4E0&color=D31148'" />
          <div class="flex-1 min-w-0">
            <div class="font-semibold text-gray-900 truncate">@{{ collab.userName }}</div>
            <div class="text-sm text-gray-500 truncate">{{ collab.displayName }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- TAGGED PEOPLE MODAL -->
  <div *ngIf="showTaggedModal" class="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4"
    (click)="closeTaggedPeopleModal()">
    <div class="bg-white rounded-2xl max-w-sm w-full max-h-[80vh] overflow-hidden" (click)="$event.stopPropagation()">
      <div class="flex items-center justify-between p-4 border-b border-gray-200">
        <h3 class="font-bold text-lg">Tagged People</h3>
        <button (click)="closeTaggedPeopleModal()" class="text-gray-400 hover:text-gray-600 transition-colors">
          <svg class="h-6 w-6" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        </button>
      </div>
      <div class="overflow-y-auto max-h-[calc(80vh-80px)]">
        <div *ngFor="let tagged of selectedPost?.mentions"
          class="flex items-center gap-3 p-4 hover:bg-gray-50 transition-colors cursor-pointer"
          [routerLink]="['/profile', tagged.userName, 'post']">
          <img [src]="tagged.profileImage?.urlSmall" [alt]="tagged.displayName"
            class="h-12 w-12 rounded-full object-cover border-2 border-white"
            onerror="this.src='https://ui-avatars.com/api/?name=' + encodeURIComponent(this.alt || 'U') + '&background=FFD4E0&color=D31148'" />
          <div class="flex-1 min-w-0">
            <div class="font-semibold text-gray-900 truncate">@{{ tagged.userName }}</div>
            <div class="text-sm text-gray-500 truncate">{{ tagged.displayName }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- ── LOGIN PROMPT via reusable ConfirmationPopup ── -->
  <app-confirmation-popup [isOpen]="showLoginPrompt" icon="user-add" title="Login Required"
    [message]="'To ' + loginPromptAction" [highlightedName]="loginPromptUserName"
    messageSuffix="you need to be logged in first" confirmLabel="Log In" cancelLabel="Close" (confirmed)="goToLogin()"
    (cancelled)="closeLoginPrompt()">
  </app-confirmation-popup>

  <app-friend-request-limit-popup [isOpen]="showFriendLimitPopup" [hours]="friendLimitHours"
    (closed)="showFriendLimitPopup = false"></app-friend-request-limit-popup>

  <app-confirmation-popup [isOpen]="showUnfriendConfirm" icon="warning" title="Unfriend User"
    message="Are you sure you want to unfriend this user?" confirmLabel="Unfriend" cancelLabel="Cancel"
    (confirmed)="confirmUnfriend()" (cancelled)="cancelUnfriendConfirm()"></app-confirmation-popup>

  <!-- Delete Post confirmation -->
  <app-confirmation-popup [isOpen]="showDeletePostConfirm" icon="warning" title="Delete Post"
    message="Are you sure you want to permanently delete this post? All media will also be removed."
    confirmLabel="Delete" cancelLabel="Cancel" (confirmed)="doDeletePost()" (cancelled)="cancelDeletePost()">
  </app-confirmation-popup>

  <!-- Report Post -->
  <app-report-modal [isOpen]="isReportModalOpen" targetLabel="Post" [isSubmitting]="isSubmittingReport"
    [errorMessage]="reportError" (submitted)="submitPostReport($event)" (cancelled)="closeReportModal()">
  </app-report-modal>

  <app-confirmation-popup [isOpen]="reportSuccessOpen" icon="info" title="Report Submitted"
    message="Thanks for letting us know. Our team will review it shortly." confirmLabel="" cancelLabel="Close"
    (cancelled)="closeReportSuccess()"></app-confirmation-popup>

  <!-- Block User (safeword-confirm) -->
  <app-block-user-confirm [isOpen]="showBlockUserConfirm" [targetName]="postToBlockDisplayName"
    (confirmed)="confirmBlockPostUser()" (cancelled)="cancelBlockPostUser()"></app-block-user-confirm>

</ng-template>

<ng-container *ngIf="embedded; else fullPosts">
  <ng-container [ngTemplateOutlet]="postsContent"></ng-container>
</ng-container>
<ng-template #fullPosts>
  <section class="min-h-screen bg-[#f3f3f3] px-3 pb-8 pt-5 sm:px-5 lg:px-8">
    <ng-container [ngTemplateOutlet]="postsContent"></ng-container>
  </section>
</ng-template>

<!-- Back to top button (standalone page only — hosts that embed this list add their own) -->
<app-scroll-to-top *ngIf="!embedded" />

<app-modal [isOpen]="isReactionOpen" (close)="closeReactionModal()" className="max-w-[700px]">
  <div class="relative w-full h-full flex flex-col bg-white dark:bg-gray-900 rounded-3xl overflow-hidden">
    <div class="flex-shrink-0 bg-white dark:bg-gray-900 border-b border-[#f0f0f0]">
      <div class="flex items-center gap-1 overflow-x-auto px-5 pt-5 pb-3 lg:px-8">
        <button (click)="setReactionFilter(null)"
          class="flex items-center gap-1.5 px-3 py-2 rounded-lg text-sm font-semibold whitespace-nowrap transition-colors"
          [class.text-[#D31148]]="activeReactionFilter === null" [class.border-b-2]="activeReactionFilter === null"
          [class.border-[#D31148]]="activeReactionFilter === null"
          [class.text-gray-500]="activeReactionFilter !== null">
          All <span class="font-bold">{{ reactionData?.total ?? 0 }}</span>
        </button>
        <ng-container *ngFor="let r of REACTIONS">
          <button (click)="setReactionFilter(r.type)"
            class="flex items-center gap-1 px-3 py-2 rounded-lg text-sm font-semibold whitespace-nowrap transition-colors"
            [class.text-[#D31148]]="activeReactionFilter === r.type"
            [class.border-b-2]="activeReactionFilter === r.type"
            [class.border-[#D31148]]="activeReactionFilter === r.type"
            [class.text-gray-500]="activeReactionFilter !== r.type">
            <span style="font-size:18px;line-height:1;">{{ r.emoji }}</span>
            <span>{{ reactionData?.counts?.[r.type] ?? 0 }}</span>
          </button>
        </ng-container>
      </div>
    </div>
    <div class="flex-1 overflow-y-auto px-5 py-4 lg:px-8">
      <div *ngIf="reactionsLoading" class="flex items-center justify-center py-12">
        <div class="h-8 w-8 animate-spin rounded-full border-4 border-[#e8e8e8] border-t-[#D31148]"></div>
      </div>
      <div *ngIf="!reactionsLoading" class="space-y-1">
        <div *ngFor="let item of filteredReactions"
          class="flex items-center gap-3 rounded-xl px-2 py-2.5 hover:bg-[#fafafa] transition-colors">
          <div class="relative flex-shrink-0">
            <img
              [src]="item.user?.profileImage?.urlSmall || avatarFallback(item.user?.displayName)"
              class="h-11 w-11 rounded-full object-cover border border-[#f0f0f0]" [alt]="item.user?.displayName" />
            <span
              class="absolute -bottom-0.5 -right-0.5 flex h-5 w-5 items-center justify-center rounded-full border-2 border-white text-[11px] shadow-sm"
              [style.background]="getReactionConfig(item.type)?.bg">{{ item.emoji }}</span>
          </div>
          <div class="flex-1 min-w-0">
            <div class="font-semibold text-gray-800 text-sm truncate">{{ item.user?.userName }}</div>
            <div class="text-xs text-gray-400 truncate">{{ item.user?.displayName }}</div>
          </div>
          <div class="flex items-center gap-2 flex-shrink-0">
            <button (click)="onModalFriendClick(item, $event)" *ngIf="!item.isMe"
              [title]="friendButtonTitle(item.friendship.status ?? 'NONE')"
              [disabled]="item.friendship.status === 'BLOCKED'"
              class="flex items-center justify-center w-8 h-8 rounded-full border transition-colors disabled:opacity-40"
              [ngClass]="item.friendship.status === 'FRIENDS'
                    ? 'border-emerald-500 text-emerald-500 hover:bg-emerald-50'
                    : item.friendship.status === 'PENDING_SENT'
                        ? 'border-orange-400 text-orange-400 hover:bg-orange-50'
                        : 'border-[#D31148] text-[#D31148] hover:bg-[#FFF0F3]'">
              <svg *ngIf="!item.friendship.status || item.friendship.status === 'NONE'" width="15" height="15"
                viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                <circle cx="9" cy="7" r="4" />
                <line x1="19" y1="8" x2="19" y2="14" />
                <line x1="22" y1="11" x2="16" y2="11" />
              </svg>
              <svg *ngIf="item.friendship.status === 'PENDING_SENT'" width="15" height="15" viewBox="0 0 24 24"
                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                <circle cx="9" cy="7" r="4" />
                <line x1="17" y1="8" x2="23" y2="14" />
                <line x1="23" y1="8" x2="17" y2="14" />
              </svg>
              <svg *ngIf="item.friendship.status === 'PENDING_RECEIVED'" width="15" height="15" viewBox="0 0 24 24"
                fill="none" stroke="#6366f1" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                <circle cx="9" cy="7" r="4" />
                <polyline points="16 11 18 13 22 9" />
              </svg>
              <svg *ngIf="item.friendship.status === 'FRIENDS'" width="15" height="15" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                <circle cx="9" cy="7" r="4" />
                <polyline points="16 11 18 13 22 9" />
              </svg>
              <svg *ngIf="item.friendship.status === 'BLOCKED'" width="15" height="15" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <circle cx="12" cy="12" r="10" />
                <line x1="4.93" y1="4.93" x2="19.07" y2="19.07" />
              </svg>
            </button>
            <button (click)="onModalFollowClick(item, $event)" *ngIf="!item.isMe"
              class="flex-shrink-0 px-3 py-0.5 text-xs font-semibold rounded-lg transition-colors" [ngClass]="item.isFollowed
                    ? 'text-gray-700 bg-[#f8f8f8] border border-[#d8d8d8] hover:bg-gray-100'
                    : 'text-green-700 bg-green-100 border border-green-600 hover:bg-green-200'">
              {{ item.isFollowed ? 'Unfollow' : 'Follow' }}
            </button>
          </div>
        </div>
        <div *ngIf="filteredReactions.length === 0"
          class="flex flex-col items-center justify-center py-12 text-gray-400">
          <span style="font-size:40px;">🤷</span>
          <p class="mt-2 text-sm">No reactions yet</p>
        </div>
      </div>
    </div>
  </div>
</app-modal>

<!-- Share Sheet -->
<app-share-sheet *ngIf="activeSharePost" [config]="activeSharePost" [currentCount]="activeShareCount"
  (closed)="closeShareSheet()" (countUpdated)="onShareCountUpdated($event)">
</app-share-sheet>